import Chip from '@mui/material/Chip';

export const renderTags = (value, getTagProps) => {
	return value.map((option, index) => {
		const label = typeof option === 'string' ? option : option.email;

		return (
			<Chip
				sx={{
					'& .MuiChip-deleteIcon': { fontSize: '18px', color: 'white' },
					backgroundColor: 'primary.main',
					color: 'white',
					paddingLeft: '10px',
					paddingRight: '10px'
				}}
				variant="filled"
				label={label}
				{...getTagProps({ index })}
			/>
		);
	});
};
